import Axios from 'axios'
/*import moment from 'moment'*/

async function loadDownloadables({ commit, dispatch, state }) {
  try {
    let getParameters = {
      //efToken: state.authentication.backendAccessToken,
      cubeName: state.cube.name,
    }

    const url = state.urls.backend + '/app/getDownloadList'
    const result = await Axios.get(url, {
      params: getParameters,
      headers: {
        efToken: state.authentication.backendAccessToken,
      },
    })

    commit('downloadsReceived', result.data.data)
  } catch (err) {
    dispatch('logError', 'Requesting downloadables list failed: ' + err)
  }
}

export default {
  loadDownloadables,
}
